import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() {
  }

  public setStorage(key: string, value: any): void {
    if (key && value) {
      if (value instanceof Object) {
        window.localStorage.setItem(key, JSON.stringify(value));
        return;
      }
      window.localStorage.setItem(key, value);
    }
  }

  public getStorage(key: string): any {
    return key && window.localStorage.getItem(key);
  }

  public removeStorage(key: string): any {
    return window.localStorage.removeItem(key);
  }
}

